import styled from '@emotion/styled';
import { RichTextStyle } from '../RichText';

const NavContainer = styled.div<{ hasBadge?: boolean }>`
  width: 100%;

  ${p => p.hasBadge && 'padding-top: 2.5rem;'}
`;

const Nav = styled.nav<{ textStyle: RichTextStyle }>`
  border-bottom: ${({ textStyle, theme }) =>
    `1px solid ${
      textStyle === RichTextStyle.Alternative
        ? theme.colors.neutral.white100
        : theme.colors.neutral.grey40
    }`};
  margin-bottom: ${({ theme }) => theme.spacing[40]};
  gap: ${({ theme }) => theme.spacing[70]};
  padding-right: ${({ theme }) => theme.spacing[70]};
  scrollbar-width: none;
  overflow: auto clip;
  display: flex;
`;

export { Nav, NavContainer };
